module.exports = __webpack_public_path__ + "img/cultureClose4.6df88989.png";